import type { AnchorHTMLAttributes, PropsWithChildren } from "react";
import { Link, useNavigate } from "react-router-dom";

export function AppLink({ href, children, ...props }: PropsWithChildren<Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & { href: string }>): React.JSX.Element {
  return <Link to={href} {...props}>{children}</Link>;
}

export function useAppNavigate(): (path: string, replace?: boolean) => void {
  const navigate = useNavigate();
  return (path, replace = false) => navigate(path, { replace });
}
